<template>
    <div>
        <div class="page-main">
            <div class='imgWrap' >
                <img v-for='(item, index) in imgData' :key='index' :src="item.url"  alt="">
            </div>
        </div>
    </div>
</template>

<script>
import imgData from './data.js';

export default {
    data() {
        return {
            imgData
        };
    },
    mounted() {
    },
    methods: {
        
    }
};
</script>

<style lang='stylus' scoped>
.page-main
    width 100%
    .imgWrap
        width 100%
        height 100%
        img
            width 100%
            height 100%
            display block
</style>
